import { useEffect, useState } from 'react';
import { useParams, Link, useLocation, useNavigate } from 'react-router-dom';
import { authFetch } from '../../utils/authFetch';

const VisualizarResponsavel = () => {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const url = `guardian/${id}`;
    
    // Verificar se veio da aba de responsáveis de um paciente
    const patientId = location.state?.patientId;

    const [form, setForm] = useState({
        name: '',
        email: '',
        address: '',
        neighborhood: '',
        addressNumber: '',
        addressComplement: '',
        state: '',
        city: '',
        phone: '',
        cellphone: '',
        zipCode: ''
    });

    useEffect(() => {
        authFetch(url, {            
        })
        .then(response => response.json())
        .then(data => setForm(data));
    }, [url]);

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <h4 className="font-weight-bolder mb-0">Visualizar Responsável</h4>
                    </aside>
                    <div className="column-responsive column-80">
                        <form>
                            <fieldset className="col-md-6">
                                {Object.entries(form).filter(([key]) => key !== 'id').map(([key, value]) => (
                                    <div className="mb-3" key={key}>
                                        <label>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                                        <input type="text" className="form-control" value={value || ''} readOnly />
                                    </div>
                                ))}
                                <div className="card-footer" style={{ paddingLeft: "0" }}>
                                    <button 
                                        type="button"
                                        onClick={() => {
                                            if (patientId) {
                                                navigate(`/Pacientes/${patientId}`, { state: { tab: 'responsaveis' } });
                                            } else {
                                                navigate('/');
                                            }
                                        }}
                                        className="btn btn-info btn-sm"
                                    >
                                        Voltar
                                    </button>
                                    <Link 
                                        to={`/Responsaveis/Editar/${id}`} 
                                        state={patientId ? { patientId, tab: 'responsaveis' } : {}}
                                        className="btn btn-primary btn-sm mx-1"
                                    >
                                        Editar
                                    </Link>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VisualizarResponsavel;
